import { FormattedMessage } from 'react-intl'
import styles from './AiContentFacebookPhotoNote.pcss'

const HELP_ARTICLE_URL = 'https://help.postplanner.com/en/articles/17710996'

/** Shown under the AI content toggle - Facebook drops the label on photo posts, the other networks still get it. */
export function AiContentFacebookPhotoNote(props: { className?: string }) {
  return (
    <p className={`${styles.note} ${props.className || ''}`} data-testid="ai-content-facebook-photo-note">
      <FormattedMessage id="composer.labels.ai-content.facebook-photo" />{' '}
      <a href={HELP_ARTICLE_URL} target="_blank" rel="noopener">
        <FormattedMessage id="actions.learn-more" />
      </a>
    </p>
  )
}
